import {Injectable} from '@angular/core';
import {AngularFirestore, AngularFirestoreDocument} from '@angular/fire/compat/firestore';
import {Config} from '../models/config';
import {firstValueFrom, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  private itemDoc: AngularFirestoreDocument<Config>;
  private item: Observable<Config>;

  public configs: Config[] = []

  constructor (private db: AngularFirestore) { }

  select () {
    return this.db.collection<Config>('sbccv_configs', ref => ref.orderBy('name', 'asc')).snapshotChanges();
  }

  async asyncSelect2 (): Promise<Config[]> {
    const snapshot = await firstValueFrom(
      this.db.collection<Config>('sbccv_configs', ref => ref.orderBy('name', 'asc')).get()
    );

    return snapshot.docs.map(doc => {
      const data = doc.data() as Config;
      return { ...data, id: doc.id };
    });
  }

  selectById (id) {
    this.itemDoc = this.db.doc<Config>('sbccv_configs/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  getById (id) {
    return this.db.doc<Config>('sbccv_configs/' + id)
      .get();
  }
  insert (entity: Config) {
    delete entity.id;
    return this.db.collection('sbccv_configs').add(Object.assign({}, entity));
  }

  update (entity: Config) {
    let id = entity.id;
    return this.db.collection('sbccv_configs').doc(id).set(Object.assign({}, entity));
  }

  delete (entity_id: any) {
    return this.db.collection('sbccv_configs').doc(entity_id).delete();
  }


  loadConfigs () {
    return this.db.collection<Config>('sbccv_configs', ref => ref.orderBy('name', 'asc')).snapshotChanges()
      .subscribe((result) => {

        result.forEach((item) => {

          let config: Config = new Config()
          config.id = item.payload.doc.id;
          config.name = item.payload.doc.data().name;
          config.format = item.payload.doc.data().format;
          config.plain_text = item.payload.doc.data().plain_text;
          config.plain_text_en = item.payload.doc.data().plain_text_en;
          config.html_text = item.payload.doc.data().html_text;
          config.html_text_en = item.payload.doc.data().html_text_en;

          this.configs.push(config)

        })
      })
  }

  makeMsgError (errorsCode) {
    let msgError: string
    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

}


